import { useTranslation } from '../i18n';

/**
 *  Hook to get the contextualized locale for the task plugin.
 */
export const useTaskLocale = (): ReturnType<typeof useTranslation> =>
  useTranslation();
